import { httpsCallable } from "firebase/functions";
import { functionsClient } from "./firebase";

export type ModerationActionName =
  | "no_action"
  | "dismiss"
  | "content_approved"
  | "content_removed"
  | "remove_content"
  | "warning"
  | "posting_restricted"
  | "temporary_suspension"
  | "permanent_ban";

export async function applyModerationAction(params: {
  caseId: string;
  action: ModerationActionName;
  internalReason: string;
  durationDays?: 1 | 7;
}) {
  const callable = httpsCallable(functionsClient, "moderationAction");
  return callable(params);
}
